"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const ConnectorFallback = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 30 30", testID: "connectorIcon-undefined" },
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, fillRule: "nonzero", d: "M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm0,27A12,12,0,1,1,27,15,12,12,0,0,1,15,27Z" }),
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, fillRule: "nonzero", d: "M18.05,7.12H13.71a.46.46,0,0,0-.52.35c-.84,2.19-1.7,4.38-2.55,6.57-.34.86-.67,1.72-1,2.65h5c-.57,2.43-1.13,4.8-1.68,7.17l.06,0,7.09-10.56H15.45Z" })));
};
ConnectorFallback.defaultProps = {
    color: 'currentColor',
    width: 30,
    height: 30,
};
exports.default = react_1.default.memo(ConnectorFallback);
